import firebase from 'firebase/app'
import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyC0gcjrzajijNiktWfOvoTFJjQby1_gChA",
    authDomain: "lockbox-website.firebaseapp.com",
    projectId: "lockbox-website",
    storageBucket: "lockbox-website.appspot.com",
    messagingSenderId: "98310803696",
    appId: "1:98310803696:web:e5c51c19919174a4c2f235",
    measurementId: "G-E6CD0K5JX2"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

export default db;
